class ProfileHelper {
  static getDefaults() {
    return {
      name: '',
      city: '',
    };
  }
}

export default ProfileHelper;
